module.exports = function(column) {
  return this.query.hasOwnProperty(column) &&
         this.opts.dateColumns.indexOf(column)>-1
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/is-date-filter.js